import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const alertVariants = cva(
  "aero:relative aero:w-full aero:rounded-lg aero:border aero:px-4 aero:py-3 aero:text-sm aero:[&>svg+div]:translate-y-[-3px] aero:[&>svg]:absolute aero:[&>svg]:left-4 aero:[&>svg]:top-4 aero:[&>svg]:text-foreground aero:[&>svg~*]:pl-7",
  {
    variants: {
      variant: {
        default: "aero:bg-background aero:text-foreground",
        destructive:
          "aero:border-destructive/50 aero:text-destructive aero:dark:border-destructive aero:[&>svg]:text-destructive",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>
>(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(alertVariants({ variant }), className)}
    {...props}
  />
));
Alert.displayName = "Alert";

const AlertTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h5
    ref={ref}
    className={cn(
      "aero:mb-1 aero:font-medium aero:leading-none aero:tracking-tight",
      className
    )}
    {...props}
  />
));
AlertTitle.displayName = "AlertTitle";

const AlertDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("aero:text-sm aero:[&_p]:leading-relaxed", className)}
    {...props}
  />
));
AlertDescription.displayName = "AlertDescription";

export { Alert, AlertTitle, AlertDescription };
